import { render } from "./onlineTrainList.vue?vue&type=template&id=0a01e3d8&scoped=true&ts=true"
import script from "./onlineTrainList.vue?vue&type=script&lang=ts"
export * from "./onlineTrainList.vue?vue&type=script&lang=ts"

import "./onlineTrainList.vue?vue&type=style&index=0&id=0a01e3d8&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a01e3d8"]])

export default __exports__